/**
 * What a self-signup (free trial) account may analyse. go-api does not filter
 * companies by plan, so the dashboard and dash-meta both enforce this one list.
 */

const SELF_SIGNUP_CLIENT_NAME = 'revelio_self_signup';

/**
 * Whether an account is self-signup, from its record's `client_name`. An
 * ABSENT `client_name` counts; `null` does not, because the field is nullable
 * on the wire and a paying client can come back as an explicit null.
 */
export const isSelfSignupClientName = (
  clientName: string | null | undefined
): boolean =>
  clientName === undefined || clientName === SELF_SIGNUP_CLIENT_NAME;

/**
 * Also the product's default primary companies: the dashboard derives
 * `DEFAULT_PRIMARY_COMPANIES` from this list. `selectionId` is the company
 * tree's ancestor-path id, ending in the rcid.
 */
export const SELF_SIGNUP_PLAN_COMPANIES: ReadonlyArray<{
  rcid: number;
  name: string;
  selectionId: string;
}> = [
  { rcid: 1116644, name: 'Workday', selectionId: '8_256_1116644' },
  { rcid: 919809, name: 'Snowflake', selectionId: '8_257_919809' },
  { rcid: 1005273, name: 'MongoDB', selectionId: '8_257_1005273' },
  { rcid: 1010813, name: 'Palantir', selectionId: '8_248_1010813' },
  { rcid: 256277, name: 'Slack', selectionId: '8_256_256277' },
];
